// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1_wZl","cls2":"Header-cls2_IIk Header-cls1_wZl"};